import { Button } from "@shltelemedicine/shl-ui-lib";
import { Link } from "react-router-dom";
import logo from "../../assets/nav/logo.svg";
import closeMenuIcon from "../../assets/nav/menu_close.svg";
import hamburgerMenuIcon from "../../assets/nav/menu_hamburger.svg";
import navBrand from "../../assets/nav/nav_brand.svg";
import Offline from "../../components/Offline/Offline";
import SupportModal from "../../components/SupportModal/SupportModal";
import { Constants } from "../../constants";
import { useAuthContext } from "../../context/AuthContext";
import {
  MainContextActionType,
  useMainContext,
} from "../../context/MainContext";
import useAuthorizedAction, {
  AuthorizedActionsKeys,
} from "../../hooks/useAuthorizedAction";
import useResponsive from "../../hooks/useResponsive";
import styles from "./Header.module.css";
import Navbar from "./Navbar";
import UserInfo from "./UserInfo";

const headerBgImgStyle = {
  backgroundImage: `url(${navBrand})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "81%",
  backgroundSize: "contain",
};

type HeaderProps = { sideBarOpen: boolean; onShowSideBar: () => void };

const Header = ({ sideBarOpen, onShowSideBar }: HeaderProps) => {
  const {
    state: { user },
  } = useAuthContext();

  const { isTablet } = useResponsive();

  const {
    state: {
      support: { show: showSupportModal, subject, description },
    },
    dispatch,
  } = useMainContext();

  const handleCloseSupportModal = () =>
    dispatch({
      type: MainContextActionType.SET_SHOW_SUPPORT,
      payload: { show: false },
    });

  const isProfessional = useAuthorizedAction(
    AuthorizedActionsKeys.ViewAsProfessional
  );

  const title = !isProfessional && user?.organization?.name;

  return (
    <header
      className={`${styles.header} app-shadow d-flex flex-row justify-content-sm-between align-items-center px-sm-3`}
      style={headerBgImgStyle}
    >
      {isTablet && (
        <div className="d-flex justify-content-start">
          <Button
            variant=""
            onClick={onShowSideBar}
            className={`${styles.menuLink}`}
          >
            <img src={sideBarOpen ? closeMenuIcon : hamburgerMenuIcon} alt="" />
          </Button>
          <h5 className={`${styles.title} mb-0 text-nowrap`}>{title}</h5>
        </div>
      )}

      {!isTablet && (
        <>
          <Navbar />
          <h5 className={`${styles.title} mb-0 text-truncate`}>{title}</h5>
        </>
      )}
      <div
        className={`${styles.userInfoWrapper} d-flex justify-content-${
          isTablet ? "end" : "between"
        } align-items-center ml-auto mx-sm-0`}
      >
        {sideBarOpen ? (
          <div className={`${styles.placeholderUserInfo}`}></div>
        ) : (
          <div className={`${sideBarOpen && "d-none"} `}>
            <UserInfo showName={sideBarOpen || !isTablet} />
          </div>
        )}
        <div className="mx-2"></div>
        {!isTablet && (
          <Link to="/" className={styles.logoLink}>
            <img src={logo} className="img-fluid" alt="" />
          </Link>
        )}
      </div>

      {/* show in offline mode */}
      <Offline urls={Constants.OFFLINE_CHECK_URLS} />

      <SupportModal
        show={showSupportModal}
        onClose={handleCloseSupportModal}
        email={user?.email}
        subject={subject}
        description={description}
      />
    </header>
  );
};

export default Header;
